export default /* @ngInject */ function setTitleOnRouteSuccess($rootScope, $route) {
    let base = document.title;
    $rootScope.$on('$routeChangeSuccess', () => {
        document.title = $route.current.title || base;
    });
}



// WEBPACK FOOTER //
// ./forms/run/set-title-on-route-success.js